<template>
  <div>
    <v-navigation-drawer v-model="drawer" app clipped>
      <v-list>
        <v-list-item to="/" @click="alterarNomeDoRelatorioParaDashboard">
          <v-list-item-icon>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-icon>

          <v-list-item-title>Dashboard</v-list-item-title>
        </v-list-item>
        <v-list-group
          v-for="item in items"
          :key="item.workspaceName"
          v-model="item.active"
          :prepend-icon="item.action"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item-title
                    v-bind="attrs"
                    v-on="on"
                    v-text="item.workspaceName"
                  ></v-list-item-title>
                </template>
                <span>{{item.workspaceName}}</span>
              </v-tooltip>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="child in item.reports"
            :key="child.reportName"
            @click="abrirRelatorio(item.workspaceId, child)"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <!-- <v-list-item-icon>
                  <v-icon>{{ child.icon }}</v-icon>
                </v-list-item-icon> -->
                <v-list-item-title v-bind="attrs" v-on="on">
                  {{ child.reportName }}</v-list-item-title
                >
              </template>
              <span>{{ child.reportName }}</span>
            </v-tooltip>

            <!-- <v-list-item-icon>
            <v-icon>{{ child.icon }}</v-icon>
          </v-list-item-icon> -->
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app clipped-left dark color="primary">
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title class="logo">Portal Alterdata</v-toolbar-title>
        <v-divider vertical></v-divider>
        <span class="relatorio ml-8 mt-1 text-h6 font-weight-bold">{{ reportName }}</span>
      <v-spacer></v-spacer>

      <v-divider vertical></v-divider>
      <span class="pl-4">
        <span class="icon">
          {{ usuario.email }}
        </span>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="v-icon-exit mdi mdi-exit-to-app"
              v-bind="attrs"
              v-on="on"
              @click="logout"
            />
          </template>
          <span>Sair</span>
        </v-tooltip>
      </span>
    </v-app-bar>
  </div>
</template>

<script>
import utilsStorage from "@/utils/storage";
import usuario from "../../model/usuario/Usuario";
import routes from "@/router/routes";
import usuarioApi from "../../api/usuario/usuario-api";

export default {
  name: "Menu",
  data() {
    return {
      drawer: false,
      rotas: routes,
      usuario: new usuario(),
      items: [],
      reportName: ""
    };
  },

  methods: {
    abrirRelatorio(workspaceId, report) {

      this.reportName = report.reportName;

      this.$router
        .replace({
          name: "Relatorio",
          params: {
            workspaceId,
            reportId: report.reportId,
            reportName: report.reportName,
          },
        })
        .catch(() => {});
    },

    logout() {
      usuarioApi.logout()
      .then(() =>{
        utilsStorage.removerAutenticacao();
        this.$router.push({ name: "Login" });
      }).catch(() => {});

    },

    montarMenuDinamico(workspaces) {
      this.items = workspaces.map((w) => {
        return {
          action: "mdi-chart-tree",
          active: false,
          workspaceId: w.workspaceId,
          workspaceName: w.workspaceName,
          reports: w.reports.sort((a, b) => {
            return a.reportName.toLowerCase() < b.reportName.toLowerCase() ? -1 : a.reportName.toLowerCase() > b.reportName.toLowerCase() ? 1 : 0;
          }).map((r) => {
            return {
              reportId: r.reportId,
              reportName: r.reportName,
              path: `workspaceId/${w.workspaceId}/reportId/${r.reportId}`,
              icon: "mdi-file-chart",
            };
          }),
        };
      });
    },

    alterarNomeDoRelatorioParaDashboard() {
      this.reportName = "Dashboard"
    }
  },
  mounted() {
    this.usuario = new usuario(utilsStorage.obterUsuarioAtualStorage());
    this.montarMenuDinamico(this.usuario.workspaces);
    this.alterarNomeDoRelatorioParaLiveDesktop();
  },
};
</script>

<style lang="scss" scoped>
.sair {
  text-transform: none;
  background-color: $white;
  border: 1px solid #dadce0;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  display: inline-block;
  letter-spacing: 0.15px;
  margin: 16px;
  outline: 0;
  padding: 10px 24px;
  text-align: center;
  text-decoration: none;
  white-space: normal;
  font-size: 12px;
  color: #5f6368;
}
.v-icon-exit {
  padding: 8px;
  border-radius: 50%;
  margin-left: 12px;
}
button:hover {
  background: #404ea7;
}
/*  mudando o menu lateral */
.v-item--active.v-list-item--active.v-list-item.v-list-item--link,
.v-list .v-list-item--active .v-icon {
  color: $cor_primaria;
}
.v-application--is-ltr
  .v-list-group--no-action
  > .v-list-group__items
  > .v-list-item {
  padding-left: 30px;
}

.v-list-item__title {
  font-size: 15px;
}

.logo {
  margin-right: 30px;
}

.relatorio {
  margin-bottom: 4px; 
}
</style>
